/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineComponent } from 'vue'
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@tarojs/components/dist/types/components';

// @ts-ignore
import { defineCustomElementTaroAdCore as defineTaroAdCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAdCustomCore as defineTaroAdCustomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAnimationVideoCore as defineTaroAnimationVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAnimationViewCore as defineTaroAnimationViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroArCameraCore as defineTaroArCameraCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAudioCore as defineTaroAudioCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAwemeDataCore as defineTaroAwemeDataCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroBlockCore as defineTaroBlockCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroButtonCore as defineTaroButtonCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCameraCore as defineTaroCameraCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCanvasCore as defineTaroCanvasCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroChannelLiveCore as defineTaroChannelLiveCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroChannelVideoCore as defineTaroChannelVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCheckboxCore as defineTaroCheckboxCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCheckboxGroupCore as defineTaroCheckboxGroupCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCommentDetailCore as defineTaroCommentDetailCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCommentListCore as defineTaroCommentListCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroContactButtonCore as defineTaroContactButtonCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCoverImageCore as defineTaroCoverImageCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCoverViewCore as defineTaroCoverViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCustomWrapperCore as defineTaroCustomWrapperCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroDoubleTapGestureHandlerCore as defineTaroDoubleTapGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroDraggableSheetCore as defineTaroDraggableSheetCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroEditorCore as defineTaroEditorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFollowSwanCore as defineTaroFollowSwanCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroForcePressGestureHandlerCore as defineTaroForcePressGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFormCore as defineTaroFormCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFunctionalPageNavigatorCore as defineTaroFunctionalPageNavigatorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroGridBuilderCore as defineTaroGridBuilderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroGridViewCore as defineTaroGridViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroHorizontalDragGestureHandlerCore as defineTaroHorizontalDragGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroIconCore as defineTaroIconCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroImageCore as defineTaroImageCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroInlinePaymentPanelCore as defineTaroInlinePaymentPanelCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroInputCore as defineTaroInputCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroKeyboardAccessoryCore as defineTaroKeyboardAccessoryCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLabelCore as defineTaroLabelCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLifestyleCore as defineTaroLifestyleCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLikeCore as defineTaroLikeCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroListBuilderCore as defineTaroListBuilderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroListViewCore as defineTaroListViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLivePlayerCore as defineTaroLivePlayerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLivePusherCore as defineTaroLivePusherCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLoginCore as defineTaroLoginCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLongPressGestureHandlerCore as defineTaroLongPressGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLottieCore as defineTaroLottieCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMapCore as defineTaroMapCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMatchMediaCore as defineTaroMatchMediaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMovableAreaCore as defineTaroMovableAreaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMovableViewCore as defineTaroMovableViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNativeSlotCore as defineTaroNativeSlotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNavigationBarCore as defineTaroNavigationBarCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNavigatorCore as defineTaroNavigatorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNestedScrollBodyCore as defineTaroNestedScrollBodyCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNestedScrollHeaderCore as defineTaroNestedScrollHeaderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOfficialAccountCore as defineTaroOfficialAccountCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOpenContainerCore as defineTaroOpenContainerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOpenDataCore as defineTaroOpenDataCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOpenEmbeddedAtomicserviceCore as defineTaroOpenEmbeddedAtomicserviceCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPageContainerCore as defineTaroPageContainerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPageMetaCore as defineTaroPageMetaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPanGestureHandlerCore as defineTaroPanGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerCore as defineTaroPickerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerGroup as defineTaroPickerGroup } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerViewColumnCore as defineTaroPickerViewColumnCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerViewCore as defineTaroPickerViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroProgressCore as defineTaroProgressCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPullToRefreshCore as defineTaroPullToRefreshCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRadioCore as defineTaroRadioCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRadioGroupCore as defineTaroRadioGroupCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRichTextCore as defineTaroRichTextCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRootPortalCore as defineTaroRootPortalCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRtcRoomCore as defineTaroRtcRoomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRtcRoomItemCore as defineTaroRtcRoomItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroScaleGestureHandlerCore as defineTaroScaleGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroScriptCore as defineTaroScriptCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroScrollViewCore as defineTaroScrollViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroShareElementCore as defineTaroShareElementCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSliderCore as defineTaroSliderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSlotCore as defineTaroSlotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSnapshotCore as defineTaroSnapshotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSpanCore as defineTaroSpanCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroStickyHeaderCore as defineTaroStickyHeaderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroStickySectionCore as defineTaroStickySectionCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwiperCore as defineTaroSwiperCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwiperItemCore as defineTaroSwiperItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwitchCore as defineTaroSwitchCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabItemCore as defineTaroTabItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabbar as defineTaroTabbar } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabsCore as defineTaroTabsCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTapGestureHandlerCore as defineTaroTapGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTextCore as defineTaroTextCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTextareaCore as defineTaroTextareaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVerticalDragGestureHandlerCore as defineTaroVerticalDragGestureHandlerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoControl as defineTaroVideoControl } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoCore as defineTaroVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoDanmu as defineTaroVideoDanmu } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroViewCore as defineTaroViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVoipRoomCore as defineTaroVoipRoomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroWebViewCore as defineTaroWebViewCore } from '@tarojs/components/dist/components';


export const Ad = /*@__PURE__*/ defineContainer<JSX.TaroAdCore>('taro-ad-core', defineTaroAdCore);


export const AdCustom = /*@__PURE__*/ defineContainer<JSX.TaroAdCustomCore>('taro-ad-custom-core', defineTaroAdCustomCore);


export const AnimationVideo = /*@__PURE__*/ defineContainer<JSX.TaroAnimationVideoCore>('taro-animation-video-core', defineTaroAnimationVideoCore);


export const AnimationView = /*@__PURE__*/ defineContainer<JSX.TaroAnimationViewCore>('taro-animation-view-core', defineTaroAnimationViewCore);


export const ArCamera = /*@__PURE__*/ defineContainer<JSX.TaroArCameraCore>('taro-ar-camera-core', defineTaroArCameraCore);


export const Audio = /*@__PURE__*/ defineContainer<JSX.TaroAudioCore>('taro-audio-core', defineTaroAudioCore, [
  'src',
  'controls',
  'autoplay',
  'loop',
  'muted',
  'nativeProps',
  'error',
  'play',
  'pause',
  'timeupdate',
  'ended'
]);


export const AwemeData = /*@__PURE__*/ defineContainer<JSX.TaroAwemeDataCore>('taro-aweme-data-core', defineTaroAwemeDataCore);


export const Block = defineComponent((__props, { slots }) => slots.default);


export const Button = /*@__PURE__*/ defineContainer<JSX.TaroButtonCore>('taro-button-core', defineTaroButtonCore, [
  'disabled',
  'hoverClass',
  'type',
  'hoverStartTime',
  'hoverStayTime',
  'size',
  'plain',
  'loading',
  'formType',
  'tarobuttonsubmit',
  'tarobuttonreset'
]);


export const Camera = /*@__PURE__*/ defineContainer<JSX.TaroCameraCore>('taro-camera-core', defineTaroCameraCore);


export const Canvas = /*@__PURE__*/ defineContainer<JSX.TaroCanvasCore>('taro-canvas-core', defineTaroCanvasCore, [
  'canvasId',
  'height',
  'width',
  'nativeProps',
  'longtap'
]);


export const ChannelLive = /*@__PURE__*/ defineContainer<JSX.TaroChannelLiveCore>('taro-channel-live-core', defineTaroChannelLiveCore);


export const ChannelVideo = /*@__PURE__*/ defineContainer<JSX.TaroChannelVideoCore>('taro-channel-video-core', defineTaroChannelVideoCore);


export const Checkbox = /*@__PURE__*/ defineContainer<JSX.TaroCheckboxCore>('taro-checkbox-core', defineTaroCheckboxCore, [
  'name',
  'value',
  'color',
  'id',
  'checked',
  'disabled',
  'nativeProps',
  'checkboxchange'
]);


export const CheckboxGroup = /*@__PURE__*/ defineContainer<JSX.TaroCheckboxGroupCore>('taro-checkbox-group-core', defineTaroCheckboxGroupCore, [
  'name',
  'change'
]);


export const CommentDetail = /*@__PURE__*/ defineContainer<JSX.TaroCommentDetailCore>('taro-comment-detail-core', defineTaroCommentDetailCore);


export const CommentList = /*@__PURE__*/ defineContainer<JSX.TaroCommentListCore>('taro-comment-list-core', defineTaroCommentListCore);


export const ContactButton = /*@__PURE__*/ defineContainer<JSX.TaroContactButtonCore>('taro-contact-button-core', defineTaroContactButtonCore);


export const CoverImage = /*@__PURE__*/ defineContainer<JSX.TaroCoverImageCore>('taro-cover-image-core', defineTaroCoverImageCore, [
  'src',
  'nativeProps',
  'load',
  'error'
]);


export const CoverView = /*@__PURE__*/ defineContainer<JSX.TaroCoverViewCore>('taro-cover-view-core', defineTaroCoverViewCore, [
  'animation',
  'hoverClass',
  'hoverStartTime',
  'hoverStayTime',
  'longpress'
]);


export const CustomWrapper = /*@__PURE__*/ defineContainer<JSX.TaroCustomWrapperCore>('taro-custom-wrapper-core', defineTaroCustomWrapperCore);


export const DoubleTapGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroDoubleTapGestureHandlerCore>('taro-double-tap-gesture-handler-core', defineTaroDoubleTapGestureHandlerCore);


export const DraggableSheet = /*@__PURE__*/ defineContainer<JSX.TaroDraggableSheetCore>('taro-draggable-sheet-core', defineTaroDraggableSheetCore);


export const Editor = /*@__PURE__*/ defineContainer<JSX.TaroEditorCore>('taro-editor-core', defineTaroEditorCore);


export const FollowSwan = /*@__PURE__*/ defineContainer<JSX.TaroFollowSwanCore>('taro-follow-swan-core', defineTaroFollowSwanCore);


export const ForcePressGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroForcePressGestureHandlerCore>('taro-force-press-gesture-handler-core', defineTaroForcePressGestureHandlerCore);


export const Form = /*@__PURE__*/ defineContainer<JSX.TaroFormCore>('taro-form-core', defineTaroFormCore, [
  'submit'
]);


export const FunctionalPageNavigator = /*@__PURE__*/ defineContainer<JSX.TaroFunctionalPageNavigatorCore>('taro-functional-page-navigator-core', defineTaroFunctionalPageNavigatorCore);


export const GridBuilder = /*@__PURE__*/ defineContainer<JSX.TaroGridBuilderCore>('taro-grid-builder-core', defineTaroGridBuilderCore);


export const GridView = /*@__PURE__*/ defineContainer<JSX.TaroGridViewCore>('taro-grid-view-core', defineTaroGridViewCore);


export const HorizontalDragGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroHorizontalDragGestureHandlerCore>('taro-horizontal-drag-gesture-handler-core', defineTaroHorizontalDragGestureHandlerCore);


export const Icon = /*@__PURE__*/ defineContainer<JSX.TaroIconCore>('taro-icon-core', defineTaroIconCore, [
  'type',
  'size',
  'color'
]);


export const Image = /*@__PURE__*/ defineContainer<JSX.TaroImageCore>('taro-image-core', defineTaroImageCore, [
  'src',
  'mode',
  'lazyLoad',
  'nativeProps',
  'load',
  'error'
]);


export const InlinePaymentPanel = /*@__PURE__*/ defineContainer<JSX.TaroInlinePaymentPanelCore>('taro-inline-payment-panel-core', defineTaroInlinePaymentPanelCore);


export const Input = /*@__PURE__*/ defineContainer<JSX.TaroInputCore>('taro-input-core', defineTaroInputCore, [
  'value',
  'type',
  'password',
  'placeholder',
  'disabled',
  'maxlength',
  'autoFocus',
  'confirmType',
  'name',
  'readonly',
  'nativeProps',
  'input',
  'paste',
  'focus',
  'blur',
  'confirm',
  'change',
  'keydown'
],
'value', 'input');


export const KeyboardAccessory = /*@__PURE__*/ defineContainer<JSX.TaroKeyboardAccessoryCore>('taro-keyboard-accessory-core', defineTaroKeyboardAccessoryCore);


export const Label = /*@__PURE__*/ defineContainer<JSX.TaroLabelCore>('taro-label-core', defineTaroLabelCore, [
  'for'
]);


export const Lifestyle = /*@__PURE__*/ defineContainer<JSX.TaroLifestyleCore>('taro-lifestyle-core', defineTaroLifestyleCore);


export const Like = /*@__PURE__*/ defineContainer<JSX.TaroLikeCore>('taro-like-core', defineTaroLikeCore);


export const ListBuilder = /*@__PURE__*/ defineContainer<JSX.TaroListBuilderCore>('taro-list-builder-core', defineTaroListBuilderCore);


export const ListView = /*@__PURE__*/ defineContainer<JSX.TaroListViewCore>('taro-list-view-core', defineTaroListViewCore);


export const LivePlayer = /*@__PURE__*/ defineContainer<JSX.TaroLivePlayerCore>('taro-live-player-core', defineTaroLivePlayerCore);


export const LivePusher = /*@__PURE__*/ defineContainer<JSX.TaroLivePusherCore>('taro-live-pusher-core', defineTaroLivePusherCore);


export const Login = /*@__PURE__*/ defineContainer<JSX.TaroLoginCore>('taro-login-core', defineTaroLoginCore);


export const LongPressGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroLongPressGestureHandlerCore>('taro-long-press-gesture-handler-core', defineTaroLongPressGestureHandlerCore);


export const Lottie = /*@__PURE__*/ defineContainer<JSX.TaroLottieCore>('taro-lottie-core', defineTaroLottieCore);


export const Map = /*@__PURE__*/ defineContainer<JSX.TaroMapCore>('taro-map-core', defineTaroMapCore, [
  'latitude',
  'longitude',
  'scale',
  'minScale',
  'maxScale',
  'markers',
  'polyline',
  'circles',
  'polygons',
  'subkey',
  'layerStyle',
  'rotate',
  'skew',
  'showCompass',
  'showScale',
  'enableOverlooking',
  'enableZoom',
  'enableScroll',
  'enableRotate',
  'enableSatellite',
  'enableTraffic',
  'enableBuilding',
  'enableAutoMaxOverlooking',
  'enable3D',
  'width',
  'height',
  'tap'
]);


export const MatchMedia = /*@__PURE__*/ defineContainer<JSX.TaroMatchMediaCore>('taro-match-media-core', defineTaroMatchMediaCore);


export const MovableArea = /*@__PURE__*/ defineContainer<JSX.TaroMovableAreaCore>('taro-movable-area-core', defineTaroMovableAreaCore, [
  'scaleArea'
]);


export const MovableView = /*@__PURE__*/ defineContainer<JSX.TaroMovableViewCore>('taro-movable-view-core', defineTaroMovableViewCore, [
  'x',
  'y',
  'direction',
  'outOfBounds',
  'inertia',
  'friction',
  'damping',
  'disabled',
  'scale',
  'scaleMin',
  'scaleMax',
  'scaleValue',
  'animation',
  'change',
  'scale',
  'htouchmove',
  'vtouchmove'
]);


export const NativeSlot = /*@__PURE__*/ defineContainer<JSX.TaroNativeSlotCore>('taro-native-slot-core', defineTaroNativeSlotCore);


export const NavigationBar = /*@__PURE__*/ defineContainer<JSX.TaroNavigationBarCore>('taro-navigation-bar-core', defineTaroNavigationBarCore);


export const Navigator = /*@__PURE__*/ defineContainer<JSX.TaroNavigatorCore>('taro-navigator-core', defineTaroNavigatorCore, [
  'hoverClass',
  'url',
  'openType',
  'isHover',
  'delta',
  'cuccess',
  'fail',
  'complete'
]);


export const NestedScrollBody = /*@__PURE__*/ defineContainer<JSX.TaroNestedScrollBodyCore>('taro-nested-scroll-body-core', defineTaroNestedScrollBodyCore);


export const NestedScrollHeader = /*@__PURE__*/ defineContainer<JSX.TaroNestedScrollHeaderCore>('taro-nested-scroll-header-core', defineTaroNestedScrollHeaderCore);


export const OfficialAccount = /*@__PURE__*/ defineContainer<JSX.TaroOfficialAccountCore>('taro-official-account-core', defineTaroOfficialAccountCore);


export const OpenContainer = /*@__PURE__*/ defineContainer<JSX.TaroOpenContainerCore>('taro-open-container-core', defineTaroOpenContainerCore);


export const OpenData = /*@__PURE__*/ defineContainer<JSX.TaroOpenDataCore>('taro-open-data-core', defineTaroOpenDataCore);


export const OpenEmbeddedAtomicservice = /*@__PURE__*/ defineContainer<JSX.TaroOpenEmbeddedAtomicserviceCore>('taro-open-embedded-atomicservice-core', defineTaroOpenEmbeddedAtomicserviceCore);


export const PageContainer = /*@__PURE__*/ defineContainer<JSX.TaroPageContainerCore>('taro-page-container-core', defineTaroPageContainerCore);


export const PageMeta = /*@__PURE__*/ defineContainer<JSX.TaroPageMetaCore>('taro-page-meta-core', defineTaroPageMetaCore);


export const PanGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroPanGestureHandlerCore>('taro-pan-gesture-handler-core', defineTaroPanGestureHandlerCore);


export const Picker = /*@__PURE__*/ defineContainer<JSX.TaroPickerCore>('taro-picker-core', defineTaroPickerCore, [
  'mode',
  'disabled',
  'range',
  'rangeKey',
  'value',
  'start',
  'end',
  'fields',
  'name',
  'textProps',
  'change',
  'columnchange',
  'cancel'
],
'value', 'change');


export const PickerGroup = /*@__PURE__*/ defineContainer<JSX.TaroPickerGroup>('taro-picker-group', defineTaroPickerGroup, [
  'mode',
  'range',
  'rangeKey',
  'height',
  'columnId',
  'updateHeight',
  'updateDay',
  'columnChange'
]);


export const PickerViewColumn = /*@__PURE__*/ defineContainer<JSX.TaroPickerViewColumnCore>('taro-picker-view-column-core', defineTaroPickerViewColumnCore, [
  'col',
  'initialPosition',
  'paddingVertical',
  'onselect',
  'onselectstart',
  'onselectend'
]);


export const PickerView = /*@__PURE__*/ defineContainer<JSX.TaroPickerViewCore>('taro-picker-view-core', defineTaroPickerViewCore, [
  'indicatorStyle',
  'indicatorClass',
  'value',
  'maskStyle',
  'maskClass',
  'change',
  'pickstart',
  'pickend'
]);


export const Progress = /*@__PURE__*/ defineContainer<JSX.TaroProgressCore>('taro-progress-core', defineTaroProgressCore, [
  'percent',
  'showInfo',
  'borderRadius',
  'fontSize',
  'strokeWidth',
  'activeColor',
  'backgroundColor',
  'active'
]);


export const PullToRefresh = /*@__PURE__*/ defineContainer<JSX.TaroPullToRefreshCore>('taro-pull-to-refresh-core', defineTaroPullToRefreshCore, [
  'prefixCls',
  'distanceToRefresh',
  'damping',
  'indicator',
  'refresh'
]);


export const Radio = /*@__PURE__*/ defineContainer<JSX.TaroRadioCore>('taro-radio-core', defineTaroRadioCore, [
  'name',
  'value',
  'id',
  'checked',
  'disabled',
  'nativeProps',
  'radiochange'
]);


export const RadioGroup = /*@__PURE__*/ defineContainer<JSX.TaroRadioGroupCore>('taro-radio-group-core', defineTaroRadioGroupCore, [
  'name',
  'change'
]);


export const RichText = /*@__PURE__*/ defineContainer<JSX.TaroRichTextCore>('taro-rich-text-core', defineTaroRichTextCore, [
  'nodes',
  'selectable',
  'userSelect',
  'space'
]);


export const RootPortal = /*@__PURE__*/ defineContainer<JSX.TaroRootPortalCore>('taro-root-portal-core', defineTaroRootPortalCore);


export const RtcRoom = /*@__PURE__*/ defineContainer<JSX.TaroRtcRoomCore>('taro-rtc-room-core', defineTaroRtcRoomCore);


export const RtcRoomItem = /*@__PURE__*/ defineContainer<JSX.TaroRtcRoomItemCore>('taro-rtc-room-item-core', defineTaroRtcRoomItemCore);


export const ScaleGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroScaleGestureHandlerCore>('taro-scale-gesture-handler-core', defineTaroScaleGestureHandlerCore);


export const Script = /*@__PURE__*/ defineContainer<JSX.TaroScriptCore>('taro-script-core', defineTaroScriptCore);


export const ScrollView = /*@__PURE__*/ defineContainer<JSX.TaroScrollViewCore>('taro-scroll-view-core', defineTaroScrollViewCore, [
  'scrollX',
  'scrollY',
  'upperThreshold',
  'lowerThreshold',
  'mpScrollTop',
  'mpScrollLeft',
  'mpScrollIntoView',
  'mpScrollIntoViewAlignment',
  'animated',
  'enhanced',
  'showScrollbar',
  'scroll',
  'scrolltoupper',
  'scrolltolower'
]);


export const ShareElement = /*@__PURE__*/ defineContainer<JSX.TaroShareElementCore>('taro-share-element-core', defineTaroShareElementCore);


export const Slider = /*@__PURE__*/ defineContainer<JSX.TaroSliderCore>('taro-slider-core', defineTaroSliderCore, [
  'min',
  'max',
  'step',
  'disabled',
  'value',
  'activeColor',
  'backgroundColor',
  'blockSize',
  'blockColor',
  'showValue',
  'name',
  'change',
  'changing'
],
'value', 'change');


export const Slot = /*@__PURE__*/ defineContainer<JSX.TaroSlotCore>('taro-slot-core', defineTaroSlotCore);


export const Snapshot = /*@__PURE__*/ defineContainer<JSX.TaroSnapshotCore>('taro-snapshot-core', defineTaroSnapshotCore);


export const Span = /*@__PURE__*/ defineContainer<JSX.TaroSpanCore>('taro-span-core', defineTaroSpanCore);


export const StickyHeader = /*@__PURE__*/ defineContainer<JSX.TaroStickyHeaderCore>('taro-sticky-header-core', defineTaroStickyHeaderCore);


export const StickySection = /*@__PURE__*/ defineContainer<JSX.TaroStickySectionCore>('taro-sticky-section-core', defineTaroStickySectionCore);


export const Swiper = /*@__PURE__*/ defineContainer<JSX.TaroSwiperCore>('taro-swiper-core', defineTaroSwiperCore, [
  'indicatorDots',
  'indicatorColor',
  'indicatorActiveColor',
  'autoplay',
  'current',
  'currentItemId',
  'interval',
  'duration',
  'circular',
  'vertical',
  'previousMargin',
  'nextMargin',
  'displayMultipleItems',
  'full',
  'zoom',
  'effectsProps',
  'change',
  'animationfinish'
]);


export const SwiperItem = /*@__PURE__*/ defineContainer<JSX.TaroSwiperItemCore>('taro-swiper-item-core', defineTaroSwiperItemCore, [
  'itemId'
]);


export const Switch = /*@__PURE__*/ defineContainer<JSX.TaroSwitchCore>('taro-switch-core', defineTaroSwitchCore, [
  'type',
  'checked',
  'color',
  'name',
  'disabled',
  'nativeProps',
  'change'
],
'checked', 'change');


export const TabItem = /*@__PURE__*/ defineContainer<JSX.TaroTabItemCore>('taro-tab-item-core', defineTaroTabItemCore);


export const Tabbar = /*@__PURE__*/ defineContainer<JSX.TaroTabbar>('taro-tabbar', defineTaroTabbar, [
  'conf',
  'longpress'
]);


export const Tabs = /*@__PURE__*/ defineContainer<JSX.TaroTabsCore>('taro-tabs-core', defineTaroTabsCore);


export const TapGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroTapGestureHandlerCore>('taro-tap-gesture-handler-core', defineTaroTapGestureHandlerCore);


export const Text = /*@__PURE__*/ defineContainer<JSX.TaroTextCore>('taro-text-core', defineTaroTextCore, [
  'selectable',
  'userSelect',
  'space',
  'numberOfLines'
]);


export const Textarea = /*@__PURE__*/ defineContainer<JSX.TaroTextareaCore>('taro-textarea-core', defineTaroTextareaCore, [
  'value',
  'placeholder',
  'disabled',
  'maxlength',
  'autoFocus',
  'autoHeight',
  'name',
  'nativeProps',
  'input',
  'focus',
  'blur',
  'confirm',
  'change',
  'linechange',
  'keydown'
],
'value', 'input');


export const VerticalDragGestureHandler = /*@__PURE__*/ defineContainer<JSX.TaroVerticalDragGestureHandlerCore>('taro-vertical-drag-gesture-handler-core', defineTaroVerticalDragGestureHandlerCore);


export const VideoControl = /*@__PURE__*/ defineContainer<JSX.TaroVideoControl>('taro-video-control', defineTaroVideoControl, [
  'controls',
  'currentTime',
  'duration',
  'isPlaying',
  'pauseFunc',
  'playFunc',
  'seekFunc',
  'showPlayBtn',
  'showProgress'
]);


export const Video = /*@__PURE__*/ defineContainer<JSX.TaroVideoCore>('taro-video-core', defineTaroVideoCore, [
  'src',
  'duration',
  'controls',
  'autoplay',
  'loop',
  'muted',
  'initialTime',
  'poster',
  'objectFit',
  'showProgress',
  'showFullscreenBtn',
  'showPlayBtn',
  'showCenterPlayBtn',
  'showMuteBtn',
  'danmuList',
  'danmuBtn',
  'enableDanmu',
  'enablePlayGesture',
  'enableProgressGesture',
  'vslideGesture',
  'vslideGestureInFullscreen',
  'nativeProps',
  'play',
  'pause',
  'ended',
  'timeupdate',
  'error',
  'fullscreenchange',
  'progress',
  'loadedmetadata'
]);


export const VideoDanmu = /*@__PURE__*/ defineContainer<JSX.TaroVideoDanmu>('taro-video-danmu', defineTaroVideoDanmu, [
  'enable'
]);


export const View = /*@__PURE__*/ defineContainer<JSX.TaroViewCore>('taro-view-core', defineTaroViewCore, [
  'animation',
  'hoverClass',
  'hoverStartTime',
  'hoverStayTime',
  'longpress'
]);


export const VoipRoom = /*@__PURE__*/ defineContainer<JSX.TaroVoipRoomCore>('taro-voip-room-core', defineTaroVoipRoomCore);


export const WebView = /*@__PURE__*/ defineContainer<JSX.TaroWebViewCore>('taro-web-view-core', defineTaroWebViewCore, [
  'src',
  'load',
  'error'
]);

